import type { BackgroundOption } from "../config/assets";

export const BACKGROUND_CATEGORIES = ["School", "Celebrations", "Events", "Sports", "Holidays", "General"] as const;
export type BackgroundCategory = typeof BACKGROUND_CATEGORIES[number];

export function backgroundCategory(option: BackgroundOption): BackgroundCategory {
  const name = option.value.split("/").pop() || "";
  if (/birthday|graduation|achievement|prom-/.test(name)) return "Celebrations";
  if (/rugby|sports|karate|swimming|ballet|dance/.test(name)) return "Sports";
  if (/coastal|ocean|sunset-school|garden-courtyard/.test(name)) return "Holidays";
  if (/golden-school-hall|blue-sky-campus|important|lift|special.guest/.test(name)) return "Events";
  if (/school|classroom|books|pencil|study|backpack|math|daycare|textbook|uniform|speech|enrollment|aftercare/.test(name)) return "School";
  return "General";
}

export function filterBackgrounds(options: BackgroundOption[], category: string, search: string) {
  const words = search.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return options.filter(option => {
    const group = backgroundCategory(option);
    const searchable = `${option.value ? option.label : "Default No Background"} ${group} ${option.value}`.toLowerCase();
    return (category === "All" || group === category) && words.every(word => searchable.includes(word));
  });
}

/** Local keyword matching only: notice content never leaves the composer. */
export function suggestedBackgrounds(options: BackgroundOption[], text: string) {
  const keywords = text.toLowerCase();
  const pattern = /birthday|bday/.test(keywords) ? /birthday/
    : /graduat|certificate|award|achievement|congrat/.test(keywords) ? /graduation|achievement/
    : /prom|dance|gala|party/.test(keywords) ? /prom-/
    : /sport|rugby|soccer|football|swim/.test(keywords) ? /rugby|sports|swimming/
    : /holiday|vacation|break/.test(keywords) ? /coastal|ocean|garden-courtyard/
    : null;
  const matches = pattern ? options.filter(option => pattern.test(option.value)) : [];
  return (matches.length ? matches : options.filter(option => option.value)).slice(0, 5);
}
